import { autobind, connect, Component } from 'macguffin'
import BackgroundImage from 'utils/BackgroundImage'
import { hideSplash } from 'macguffin/redux/actions'

const logoStyle = {
  backgroundPosition: 'top center'
}

const splashScatterStyle = {
  position: 'relative',
  backgroundPosition: 'center'
}

const starsStyle = {
  backgroundPosition: 'top center',
  backgroundSize: 'auto',
  backgroundRepeat: 'repeat'
}

const marsStyle = {
  position: 'absolute',
  zIndex: '-1',
  left: '70%',
  bottom: '45%',
  width: '30%',
  height: '30%',
  backgroundPosition: 'center'
}

const cometStyle = {
  backgroundPosition: 'center'
}

@connect(
  state => ({ messages: state.base.messages }),
  { hideSplash }
)
export default class Splash extends Component {
  render() {
    const {
      props: { hideSplash }
    } = this

    return (
      <div
        className="splashContainer continue"
        onClick={hideSplash}
        onTouchEnd={hideSplash}
      >
        <div className="splashContents">
          <BackgroundImage
            className="gameLogo"
            assetName="loadingLogo"
            style={logoStyle}
          />

          <div className="splashDetails">
            <div className="splashInfo scatterSymbols">
              <h1>{this.t('splash.collectScatters')}</h1>
              <div className="splashScatterContainer">
                <div />
                <BackgroundImage
                  className="splashScatter"
                  assetName="scatterMeterLevel"
                  style={splashScatterStyle}
                />
                <BackgroundImage
                  className="splashScatter"
                  assetName="scatterMeterLevel"
                  style={splashScatterStyle}
                />
                <BackgroundImage
                  className="splashScatter"
                  assetName="scatterMeterLevel"
                  style={splashScatterStyle}
                />
                <BackgroundImage
                  className="splashScatter"
                  assetName="scatterMeterLevel"
                  style={splashScatterStyle}
                />
                <BackgroundImage
                  className="splashScatter"
                  assetName="scatterMeterLevel"
                  style={splashScatterStyle}
                />
              </div>
            </div>
            <div className="splashInfo">
              <BackgroundImage
                className="shipSymbol"
                assetName="splashScreenMars"
                style={marsStyle}
              />
              <h1>{this.t('splash.jackpotChance')}</h1>
            </div>
            <div className="splashInfo cometSymbol">
              <h1>{this.t('splash.wildRespins')}</h1>
              <BackgroundImage
                className="splashComet"
                assetName="splashScreenComet"
                style={cometStyle}
              />
            </div>
          </div>
          <h1 className="tapContinue">{this.t('ui.taptocontinue')}</h1>
        </div>
        <BackgroundImage
          className="marsStarsBackground"
          assetName="stars1"
          style={starsStyle}
        />
        <BackgroundImage
          className="marsStars2Background"
          assetName="stars2"
          style={starsStyle}
        />
        <BackgroundImage
          className="marsStars3Background"
          assetName="stars3"
          style={starsStyle}
        />
      </div>
    )
  }
}
